import React from 'react';
import { useSelector } from 'react-redux';
import { getPopups } from '../selectors';
import { Csku, Theme, themeOptions } from '@commonsku/styles';
import { createGlobalStyle } from '../components/helpers';
import ErrorBoundary from '../components/ErrorBoundary';
import MainSection from './MainSection';
import Overlay from '../components/Overlay';
import Header from './Header';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import NoMatch from '../components/NoMatch';
import ChatsHomePage from '../components/skubot/ChatsHomePage';
import { useHasUserFlag } from '../hooks';
import { Provider } from '@commonsku/design-system';

export const OPPORTUNITY_AGENT_FLAG = 'OPPORTUNITY-AGENT';

const SkubotGlobalStyle = createGlobalStyle(p => `
    body {
        font-family: 'skufont-demibold', "museo-sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
        background: ${p.bodyBg || 'initial'};
    }
    .resku .main-content.skubot-main-content {
        margin-top: 0;
    }
    .resku .header-space-holder {
        min-height: 0;
    }
    .resku .modal-title-override {
        margin-bottom: 0;
    }
    @media screen and (min-width: 40em) {
        .resku .main-content.skubot-main-content {
            padding-left: 176px;
        }
    }
`);

const NoMatchRoute = React.memo(() => {
    const location = useLocation();
    return <NoMatch location={location} />;
});

export default function SkubotRouter({ location }: { location: string }) {
    return (
        <BrowserRouter basename={location}>
            <Routes>
                <Route
                    path="/skubot_chats.php"
                    element={<SkubotApp />}
                    ErrorBoundary={ErrorBoundary}
                />
                <Route
                    path={"*"}
                    element={<NoMatchRoute />}
                    ErrorBoundary={ErrorBoundary}
                />
            </Routes>
        </BrowserRouter>
    );
}

function SkubotApp() {
    const hasUserFlag = useHasUserFlag(OPPORTUNITY_AGENT_FLAG);
    const popups = useSelector(getPopups);

    if (!hasUserFlag) {
        return <NoMatchRoute />;
    }

    return (
        <Theme theme={themeOptions}>
            <SkubotGlobalStyle />
            <ErrorBoundary>
                <div style={{ background: "var(--color-neutrals-20)", minHeight: "100vh" }}>
                    <Header />
                    <MainSection popups={popups}>
                        <Csku as={"div"} className="main-content skubot-main-content">
                            <Provider>
                                <ChatsHomePage />
                            </Provider>
                        </Csku>
                    </MainSection>
                </div>
                <Overlay popups={popups} />
            </ErrorBoundary>
        </Theme>
    );
}
